import * as React from 'react';

var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLorryAgentBroker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 57,
    fill: "none",
    viewBox: "0 0 49 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M9.767 51.585l-.4.3 19.71-48.18.4-.3-19.71 48.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E53FB",
    d: "M25.858 3.925l3.61-.54-19.73 48.06-9.26-41.48a1.87 1.87 0 011.35-2.39l3.61-.55c-.011.265.012.53.07.79l.28 1.24a2.703 2.703 0 002.8 2.25l16.18-2.38a2.276 2.276 0 001.502-1.128 2.29 2.29 0 00.138-1.872l-.27-1.24a3.302 3.302 0 00-.28-.76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0040BF",
    d: "M29.477 3.405c.253-.031.51-.01.753.063.245.072.472.193.667.357.445.365.755.868.88 1.43l4.23 18.9-13.28 2 5.54 24.7-16.2 2.46a1.894 1.894 0 01-1.34-.36 2.625 2.625 0 01-.93-1.37l19.68-48.18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M30.168 5.355l9.51 40.15-28.07 3.94-9.51-40.15 28.07-3.94z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M26.408 5.955l-.39.3-20.62 3.13.39-.3 20.62-3.13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E5166",
    d: "M9.367 4.605l-.39.29a3.375 3.375 0 011.59-3.11l.39-.29a3.401 3.401 0 00-1.59 3.11z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B3D51",
    d: "M24.767 8.875l-.4.3-16.17 2.46.39-.3 16.18-2.46z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M24.767 8.875l-.4.3-16.17 2.46.39-.3 16.18-2.46z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E5166",
    d: "M5.507 7.845l-.39.3a3.134 3.134 0 01-.07-.79 2.328 2.328 0 01.87-1.77l.39-.29a2.326 2.326 0 00-.869 1.76c-.012.265.012.53.07.79z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M5.787 9.085l-.39.3-.28-1.24.39-.3.28 1.24z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3F54",
    d: "M8.587 11.335l-.39.3a2.701 2.701 0 01-2.81-2.25l.4-.3a2.703 2.703 0 002.8 2.25z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E5166",
    d: "M8.587 11.335l-.39.3a2.701 2.701 0 01-2.81-2.25l.4-.3a2.703 2.703 0 002.8 2.25z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M.477 9.995l-.4.3a1.998 1.998 0 01.66-2.1l.39-.3a2.002 2.002 0 00-.65 2.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#53789F",
    d: "M5.787 9.085l20.62-3.16a2.26 2.26 0 01-.139 1.872c-.155.284-.37.532-.628.727-.26.194-.557.33-.873.4l-16.18 2.46a2.694 2.694 0 01-1.843-.61 2.704 2.704 0 01-.957-1.69z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M28.238 50.855l-.4.3-16.19 2.46.39-.3 16.2-2.46zm-16.201 2.46l-.39.3a1.882 1.882 0 01-1.34-.36l.39-.3c.385.285.864.414 1.34.36zm-2.299-1.84l-.4.3-9.26-41.48.4-.29 9.26 41.47zm.959 1.45l-.39.3a2.672 2.672 0 01-.94-1.37l.4-.3c.155.545.48 1.025.93 1.37z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M10.517 52.815l-.39.3a2.524 2.524 0 01-.76-1.23l.4-.3c.122.476.383.904.75 1.23z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M10.517 52.815l-.39.3a2.524 2.524 0 01-.76-1.23l.4-.3c.122.476.383.904.75 1.23z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M10.518 52.815a2.448 2.448 0 01-.75-1.23c.124.474.385.902.75 1.23z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#6382AA",
    d: "M14.448.105c3.16-.48 6.08.73 6.68 2.71l2.21-.33a2.525 2.525 0 011.488.32c.451.259.812.65 1.032 1.12.125.24.218.496.28.76l.27 1.24-20.62 3.13a2.7 2.7 0 002.8 2.25l16.18-2.38a2.28 2.28 0 001.502-1.127 2.267 2.267 0 00-1.502 1.127l-16.18 2.46a2.697 2.697 0 01-2.8-2.25l-.28-1.24a3.134 3.134 0 01-.07-.79 2.138 2.138 0 011.72-2.18l2.21-.33c-.29-2.02 1.9-4.01 5.08-4.49z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBA55",
    d: "M7.867 19.615a16 16 0 015.68 5.72 31.55 31.55 0 012.55-3.65 59.905 59.905 0 015.26-5.44c.84-.83 2.14-2.11 3.74-3.72a27.193 27.193 0 00-5.21 3 27.613 27.613 0 00-6.44 6.57 5.434 5.434 0 00-5.58-2.43v-.05zm2.94 9.38a16.238 16.238 0 012.8 2.1c1.13 1.06 2.1 2.28 2.88 3.62a32.317 32.317 0 012.55-3.65 64.417 64.417 0 015.23-5.44c.85-.83 2.14-2.11 3.74-3.71a27.058 27.058 0 00-5.21 3 27.409 27.409 0 00-6.44 6.57 5.453 5.453 0 00-1.85-1.79 5.683 5.683 0 00-3.7-.7zm2.9 9.3a15.861 15.861 0 015.69 5.72 32.317 32.317 0 012.55-3.65 62.275 62.275 0 015.25-5.44c.85-.83 2.15-2.11 3.75-3.71a26.66 26.66 0 00-5.21 2.95 27.061 27.061 0 00-6.47 6.57 5.524 5.524 0 00-1.82-1.81 5.705 5.705 0 00-3.74-.63z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAB753",
    d: "M30.918 3.845z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#587981",
    d: "M39.747 27.795l-.39.3 1.67-4.47.39-.29-1.67 4.46z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#747F82",
    d: "M39.747 27.795l-.39.3-.06-.27.39-.3.06.27z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#597A82",
    d: "M40.007 28.965l-.39.3-.26-1.17.39-.3.26 1.17z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M40.007 28.965l-.39.3-.74.11.4-.3.73-.11z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3F54",
    d: "M25.617 8.525l-.4.29c-.247.192-.54.316-.85.36l.4-.3c.308-.045.6-.166.85-.35z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#3E5166",
    d: "M25.617 8.525l-.4.29c-.247.192-.54.316-.85.36l.4-.3c.308-.045.6-.166.85-.35z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#597A82",
    d: "M41.257 34.565l-.39.29-.32-1.42.4-.3.31 1.43zm1.26 5.6l-.4.3-.32-1.44.4-.3.32 1.44z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#577880",
    d: "M40.948 33.135l-.4.3-3.38.51.4-.3 3.38-.51z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#587981",
    d: "M37.568 33.645l-.4.3 1.71-4.57.4-.3-1.71 4.57z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M41.258 34.565l-.39.29-4.28.65.39-.3 4.28-.64z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#597A82",
    d: "M43.767 45.765l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#587981",
    d: "M35.277 39.775l-.4.3 1.71-4.57.39-.3-1.7 4.57z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#577880",
    d: "M42.197 38.725l-.4.3-6.92 1.05.4-.3 6.92-1.05z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#597A82",
    d: "M42.068 51.815l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M42.517 40.165l-.4.3-7.83 1.19.4-.3 7.83-1.19z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#727D80",
    d: "M39.688 27.525l-.39.3-13.54 2.05.4-.29 13.53-2.06z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M26.478 31.015l-.4.3-.32-1.44.4-.29.32 1.43z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M39.278 29.075l-.4.3-12.8 1.94.4-.3 12.8-1.94zm-2.3 6.13l-.39.3-9.26 1.41.4-.3 9.25-1.41zm6.79 10.56l-.4.3-11.37 1.73.39-.3 11.38-1.73z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#587981",
    d: "M32.978 45.925l-.4.3 1.71-4.57.4-.3-1.71 4.57z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M34.688 41.355l-.4.3-5.71.86.4-.3 5.71-.86z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#577880",
    d: "M41.748 50.385l-.4.3-7.62 1.16.39-.3 7.63-1.16z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M34.438 52.975l-.4.29-.31-1.42.39-.3.32 1.43z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M42.067 51.815l-.4.3-7.63 1.15.4-.29 7.63-1.16z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#587981",
    d: "M29.318 55.705l-.39.3 3.07-8.21.39-.3-3.07 8.21z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#577880",
    d: "M48.018 52.865l-.4.3-18.69 2.84.39-.3 18.7-2.84z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#747F82",
    d: "M29.318 55.705l-.39.3-1.09-4.85.4-.3 1.08 4.85z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#00334F",
    d: "M36.008 24.155l-.4.3-13.28 2.01.4-.3 13.28-2.01z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#727D80",
    d: "M37.568 33.645l-.4.3-10.16 1.54.4-.3 10.16-1.54z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M27.728 36.615l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#577880",
    d: "M43.448 44.335l-.4.3-10.47 1.59.4-.3 10.47-1.59z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#727D80",
    d: "M35.278 39.775l-.4.3-6.62 1.01.4-.3 6.62-1.01z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M28.978 42.215l-.4.3-.32-1.43.4-.3.32 1.43z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#727D80",
    d: "M32.978 45.925l-.4.3-3.07.46.4-.3 3.07-.46z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4E62",
    d: "M32.388 47.495l-.39.3-2.17.33.4-.3 2.16-.33z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4F64",
    d: "M30.228 47.825l-.4.3-.32-1.44.4-.3.32 1.44z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8E6FF",
    d: "M41.419 23.335l-1.67 4.46-.06-.27-13.53 2.06.32 1.43 12.8-1.94-1.71 4.57-10.16 1.54.32 1.43 9.25-1.41-1.7 4.57-6.62 1.01.32 1.43 5.71-.86-1.71 4.57-3.07.46.32 1.44 2.16-.33-3.07 8.21-1.08-4.85-5.51-24.69 13.28-2.01 5.41-.82z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#97DDFC",
    d: "M41.418 23.335l-1.67 4.46.26 1.17-.73.11-1.71 4.57 3.38-.51.31 1.42-4.28.65-1.71 4.57 6.91-1 .33 1.44-7.83 1.19-1.7 4.52 10.47-1.59.32 1.44-11.38 1.72-3.07 8.21 18.7-2.84-6.6-29.53zm-7 29.64l-.32-1.43 7.63-1.16.32 1.43-7.63 1.16z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#7698C0",
    d: "M39.688 27.525l.06.27.26 1.17-.73.11-12.8 1.94-.32-1.43 13.53-2.06zm1.26 5.61l.31 1.43-4.28.64-9.25 1.41-.32-1.43 10.16-1.54 3.38-.51zm1.25 5.59l.32 1.44-7.83 1.19-5.71.86-.32-1.43 6.62-1.01 6.92-1.05zm-.451 11.66l.32 1.43-7.63 1.16-.32-1.43 7.63-1.16zm1.701-6.05l.32 1.43-11.38 1.73-2.16.33-.32-1.44 3.07-.46 10.47-1.59z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#747F82",
    d: "M28.238 50.855l-.4.3-5.51-24.69.4-.3 5.51 24.69z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#00324E",
    d: "M12.848 16.925a2.37 2.37 0 012.51 1.83l1.27 5a1.842 1.842 0 01-.178 1.536 1.844 1.844 0 01-1.282.864l-4.72.66a2.371 2.371 0 01-2.52-1.83l-1.27-5a1.859 1.859 0 01-.08-.787 1.852 1.852 0 011.54-1.613l4.73-.66zm2.89 7l-1.27-5a1.317 1.317 0 00-1.391-1l-4.72.67a.991.991 0 00-.717.468.991.991 0 00-.092.852l1.27 5a1.336 1.336 0 001.39 1l4.72-.67a.996.996 0 00.718-.468 1.006 1.006 0 00.092-.852zm-.011 2.62a2.385 2.385 0 012.54 1.84l1.27 5a1.832 1.832 0 01-.179 1.531 1.83 1.83 0 01-1.281.859l-4.73.67a2.392 2.392 0 01-2.51-1.84l-1.27-5a1.856 1.856 0 01.182-1.533c.139-.228.325-.423.545-.573.22-.15.47-.25.733-.294l4.7-.66zm2.9 7l-1.27-5a1.317 1.317 0 00-1.391-1l-4.72.66a.991.991 0 00-.41.153 1.001 1.001 0 00-.399 1.167l1.27 5a1.31 1.31 0 001.389 1l4.72-.66a1.006 1.006 0 00.864-.892.988.988 0 00-.053-.438m.152 2.61a2.385 2.385 0 012.49 1.83l1.27 5a1.877 1.877 0 01-.186 1.536 1.862 1.862 0 01-1.284.864l-4.72.66a2.386 2.386 0 01-2.52-1.83l-1.26-5a1.843 1.843 0 01.718-2.099c.22-.149.47-.248.731-.291l4.76-.67zm2.89 7l-1.26-5a1.338 1.338 0 00-1.4-1l-4.72.67a1 1 0 00-.81 1.32l1.27 5a1.334 1.334 0 001.39 1l4.72-.67a1 1 0 00.809-1.32z"
  })));
}

export { SvgLorryAgentBroker as ReactComponent };
//# sourceMappingURL=LorryAgentBroker.svg.js.map
